var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowElipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 28,
    viewBox: "0 0 106 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bf_8206_528133)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 53,
    cy: 14.3845,
    rx: 48,
    ry: 9,
    fill: "url(#paint0_linear_8206_528133)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bf_8206_528133",
    x: -32.5,
    y: -32.1155,
    width: 171,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 18.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8206_528133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8206_528133",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25,
    result: "effect2_foregroundBlur_8206_528133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8206_528133",
    x1: 5,
    y1: 14.3845,
    x2: 101,
    y2: 14.3845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4F6",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#EBECF0",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F3F4F6",
    stopOpacity: 0.41
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowElipse);
export default __webpack_public_path__ + "static/media/shadowElipse.0e1a0fbd42f430862e624fb97c9a419e.svg";
export { ForwardRef as ReactComponent };